import "./InlineLink.css";
import { Link as LinkIcon } from "./icons";

const InlineLink = ({
  href,
  children,
  icon = true,
  external = true,
  variant = "primary",
  size = "md",
  appearance = "text",
  className = "",
  ...props
}) => {
  return (
    <a
      href={href}
      className={`ui-inline-link ${variant} ${size} ${appearance} ${className}`}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      {...props}
    >
      {children}
      {icon && (
        <span className="ui-inline-link-icon">
          <LinkIcon size={14} />
        </span>
      )}
    </a>
  );
};

export default InlineLink;
